module.exports = __webpack_public_path__ + "img/25ne.23531aaf.svg";